/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useRef, useState } from "react";
import {
  AboutDiv,
  InformationContainer,
  InformationDiv,
  InformationHeading,
  MainContainer,
  ProfileDiv,
} from "../Profile/Profile.style";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MedicalInformationIcon from "@mui/icons-material/MedicalInformation";

import { useSelector } from "react-redux";
import {
  EmptyDiv,
  HistoryTable,
  InputContainer,
  InputLevel,
  PdfDiv,
  PidDiv,
  RegHeadingDiv,
  RegisterDiv,
  TableHeadCell,
  TableHeadTr,
} from "./Volunteer.style";
import profile from "../../Images/profile.png";
import girl from "../../Images/girl.png";
import HomeIcon from "@mui/icons-material/Home";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import AttachmentIcon from "@mui/icons-material/Attachment";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";

import moment from "moment/moment";
import { Button, TableCell } from "@mui/material";
import { BsFillPrinterFill } from "react-icons/bs";
import PdfVolProfile from "./PdfVolProfile";

const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const currentDate = new Date();

  let ageYears = currentDate.getFullYear() - birthDate.getFullYear();
  let ageMonths = currentDate.getMonth() - birthDate.getMonth();
  let ageDays = currentDate.getDate() - birthDate.getDate();
  // const handlePrint = () => {
  //   const link = document.createElement('link');
  //   link.rel = 'stylesheet';
  //   link.type = 'text/css';
  //   link.href = 'print.css';
  //   document.getElementsByTagName('head')[0].appendChild(link);
  //   window.print();
  // };
  if (ageDays < 0) {
    const lastMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - 1,
      birthDate.getDate()
    );
    ageMonths = currentDate.getMonth() - lastMonth.getMonth();
    ageDays = currentDate.getDate() - lastMonth.getDate();
  }

  let ageString = "";

  if (ageYears > 0) {
    ageString += `${ageYears} ${
      ageYears === 0 || ageYears === 1 ? "Year" : "Years"
    }`;
  }

  // if (ageMonths > 0) {
  //   if (ageString) {
  //     ageString += `, ${ageMonths} ${ageMonths === 1 ? "Month" : "Months"}`;
  //   } else {
  //     ageString = `${ageMonths} ${ageMonths === 1 ? "Month" : "Months"}`;
  //   }
  // }

  // if (ageDays >= 0) {
  //   if (ageString) {
  //     ageString += `, ${ageDays} ${
  //       ageDays === 0 || ageDays === 1 ? "Day" : "Days"
  //     }`;
  //   } else {
  //     ageString = `${ageDays} ${
  //       ageDays === 0 || ageDays === 1 ? "Day" : "Days"
  //     }`;
  //   }
  // }

  return ageString;
};

const VolunteerProfile = () => {
  const volunteerData = useSelector((state) => state.Modal.val);

  const [inputs, setInputs] = useState([]);
  const [history, setHistory] = useState([]);

  const pid = volunteerData.vol_id !== "";
  const femaleStatus = volunteerData?.sex;

  const availability = volunteerData?.availability;
  const previous_clinic_trial = volunteerData.previous_clinic_trial;

  useEffect(() => {
    const getHistory = async () => {
      const resHistory = await fetch(
        `${process.env.REACT_APP_API_URL}/api/voluntaryHistoryList/${volunteerData.vol_no}`
      );
      const resHis = await resHistory.json();
      setHistory(await resHis);
    };
    getHistory();
  }, []);

  useEffect(() => {}, [inputs]);

  return (
    <>
      <ProfileDiv>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <Button
            size="small"
            className="entries"
            onClick={() => window.print()}
            variant="outlined"
            startIcon={<BsFillPrinterFill />}
          >
            PDF Download
          </Button>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "4fr 2fr",
            gap: "1rem",
          }}
        >
          <RegHeadingDiv
            style={{
              margin: "2rem 1rem 1rem 1rem",
            }}
          >
            <div>
              {pid && (
                <InputContainer style={{ marginBottom: "1rem" }}>
                  <InputLevel
                    style={{
                      backgroundColor: "#3490DC",
                      borderColor: "#3490DC",
                    }}
                  >
                    PID Number
                  </InputLevel>
                  <PidDiv>{volunteerData?.vol_id}</PidDiv>
                </InputContainer>
              )}

              <InputContainer>
                <InputLevel>Date of Registration</InputLevel>
                <RegisterDiv>
                  {moment(volunteerData.date_of_registration).format(
                    "DD MMM YYYY"
                  )}
                </RegisterDiv>
              </InputContainer>
            </div>
          </RegHeadingDiv>

          {femaleStatus === "Female" && (
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "125px",
                  wight: "auto",
                }}
                src={volunteerData.voluntary_image || girl}
                alt=""
              />
            </div>
          )}

          {femaleStatus === "Male" && (
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "125px",
                  wight: "auto",
                }}
                src={volunteerData.voluntary_image || profile}
                alt=""
              />
            </div>
          )}

          {femaleStatus === "Others" && (
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "125px",
                  wight: "auto",
                }}
                src={volunteerData.voluntary_image || profile}
                alt=""
              />
            </div>
          )}
        </div>

        <AboutDiv className="entries" style={{ margin: " 1rem" }}>
          <AccountCircleIcon></AccountCircleIcon>
          <span
            style={{
              // color: "#1a202c",
              color: "#20215c",
              fontWeight: "600",
              letterSpacing: "0.4px",
              lineHeight: "32px",
              margin: "0px 0px 0px 8px",
            }}
          >
            About
          </span>
        </AboutDiv>

        <MainContainer>
          <InformationContainer>
            <InformationHeading>Name:</InformationHeading>
            <InformationDiv>{volunteerData?.full_name}</InformationDiv>
          </InformationContainer>
          <InformationContainer>
            <InformationHeading>Initial:</InformationHeading>
            <InformationDiv>
              {" "}
              {volunteerData?.vol_initial?.length === 1 && (
                <>--{volunteerData?.vol_initial}</>
              )}
              {volunteerData?.vol_initial?.length === 2 && (
                <>-{volunteerData?.vol_initial}</>
              )}
              {volunteerData?.vol_initial?.length === 3 && (
                <>{volunteerData?.vol_initial}</>
              )}
              {volunteerData?.vol_initial?.length > 3 && (
                <>{volunteerData?.vol_initial?.substring(0, 3)}</>
              )}{" "}
            </InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Registration Number:</InformationHeading>
            <InformationDiv>{volunteerData?.reg_no}</InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Father’s Name:</InformationHeading>
            <InformationDiv>{volunteerData?.father_name}</InformationDiv>
          </InformationContainer>
          {/* </MainContainer> */}

          {/* <MainContainer> */}
          <InformationContainer>
            <InformationHeading>Mother’s Name: </InformationHeading>
            <InformationDiv>{volunteerData?.mother_name}</InformationDiv>
          </InformationContainer>
          <InformationContainer>
            <InformationHeading>Date of Birth:</InformationHeading>
            <InformationDiv>
              {moment(volunteerData?.dob).format("DD MMM YYYY")}
            </InformationDiv>
          </InformationContainer>
          <InformationContainer>
            <InformationHeading>Age:</InformationHeading>
            <InformationDiv>{calculateAge(volunteerData.dob)}</InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Sex: </InformationHeading>
            <InformationDiv>{volunteerData?.sex}</InformationDiv>
          </InformationContainer>

          {femaleStatus === "Female" && (
            <InformationContainer>
              <InformationHeading>Father/Husband Name: </InformationHeading>
              <InformationDiv>
                {volunteerData?.v_fathr_or_husb_name}
              </InformationDiv>
            </InformationContainer>
          )}

          {femaleStatus === "Female" && (
            <InformationContainer>
              <InformationHeading>Father/Husband NID: </InformationHeading>
              <InformationDiv>
                {volunteerData?.fathr_or_husb_nid}
              </InformationDiv>
            </InformationContainer>
          )}

          <InformationContainer>
            <InformationHeading>Nationality:</InformationHeading>
            <InformationDiv>{volunteerData?.nationality}</InformationDiv>
          </InformationContainer>
          <InformationContainer>
            <InformationHeading>Occupation:</InformationHeading>
            <InformationDiv>{volunteerData?.occupation_name}</InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Marital Status: </InformationHeading>
            <InformationDiv>{volunteerData?.marital_status}</InformationDiv>
          </InformationContainer>
          {/* </MainContainer> */}

          {/* <MainContainer> */}
          <InformationContainer>
            <InformationHeading>NID:</InformationHeading>
            <InformationDiv>{volunteerData?.national_id}</InformationDiv>
          </InformationContainer>
          <InformationContainer>
            <InformationHeading>Blood Group: </InformationHeading>
            <InformationDiv>{volunteerData?.vol_blood_group}</InformationDiv>
          </InformationContainer>
          <MainContainer>
            <InformationContainer>
              <InformationHeading>NID Image: </InformationHeading>
              <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
                <img
                  style={{
                    height: "80px",
                    wight: "auto",
                  }}
                  src={volunteerData?.voluntary_nid_image}
                  alt=""
                />
              </div>
            </InformationContainer>
          </MainContainer>

          {/* <InformationContainer>
            <InformationHeading>Contact Number:</InformationHeading>
            <InformationDiv>{volunteerData.contact_phone}</InformationDiv>
          </InformationContainer> */}
          {/* </MainContainer> */}

          {/* <MainContainer> */}
          {/* <InformationContainer>
            <InformationHeading>Emergency Contact Number:</InformationHeading>
            <InformationDiv>{volunteerData.emergency_contract_ph}</InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Relative Name:</InformationHeading>
            <InformationDiv>{volunteerData.emergency_contract_nm}</InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Relation with Volunteer:</InformationHeading>
            <InformationDiv>
              {volunteerData.contact_contract_relation}
            </InformationDiv>
          </InformationContainer> */}
          {/* </MainContainer> */}

          {/* <MainContainer> */}
          {/* <InformationContainer>
            <InformationHeading>Old Volunteer Id:</InformationHeading>
            <InformationDiv>{volunteerData.old_vol_id}</InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>PRO Name:</InformationHeading>
            <InformationDiv>{volunteerData.pro_name}</InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Status:</InformationHeading>
            <InformationDiv>
              {volunteerData?.active_fg == 1 ? "Active" : "Inactive"}
            </InformationDiv>
          </InformationContainer> */}
        </MainContainer>

        <EmptyDiv></EmptyDiv>
        <AboutDiv className="entries" style={{ margin: " 1rem" }}>
          <ContactPageIcon></ContactPageIcon>
          <span
            style={{
              // color: "#1a202c",
              color: "#20215c",
              fontWeight: "600",
              letterSpacing: "0.4px",
              lineHeight: "32px",
              margin: "0px 0px 0px 8px",
            }}
          >
            Contact
          </span>
        </AboutDiv>
        <MainContainer>
          <InformationContainer>
            <InformationHeading>Contact Number:</InformationHeading>
            <InformationDiv>{volunteerData?.contact_phone}</InformationDiv>
          </InformationContainer>
          {/* </MainContainer> */}

          {/* <MainContainer> */}
          <InformationContainer>
            <InformationHeading>Email</InformationHeading>
            <InformationDiv>{volunteerData?.email}</InformationDiv>
          </InformationContainer>
          <InformationContainer>
            <InformationHeading>Emergency Contact Person:</InformationHeading>
            <InformationDiv>
              {volunteerData?.emergency_contract_nm}
            </InformationDiv>
          </InformationContainer>
          <InformationContainer>
            <InformationHeading>Emergency Contact Number:</InformationHeading>
            <InformationDiv>
              {volunteerData?.emergency_contract_ph}
            </InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Relation with Volunteer:</InformationHeading>
            <InformationDiv>
              {volunteerData.contact_contract_relation}
            </InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Old Volunteer Id:</InformationHeading>
            <InformationDiv>{volunteerData?.old_vol_id}</InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>PRO Name:</InformationHeading>
            <InformationDiv>{volunteerData?.pro_name}</InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Status:</InformationHeading>
            <InformationDiv>
              {volunteerData?.active_fg === 1 ? "Active" : "Inactive"}
            </InformationDiv>
          </InformationContainer>
          {/* </MainContainer> */}
        </MainContainer>

        <EmptyDiv></EmptyDiv>
        <AboutDiv className="entries" style={{ margin: " 1rem" }}>
          <MedicalInformationIcon></MedicalInformationIcon>
          <span
            style={{
              // color: "#1a202c",
              color: "#20215c",
              fontWeight: "600",
              letterSpacing: "0.4px",
              lineHeight: "32px",
              margin: "0px 0px 0px 8px",
            }}
          >
            Medical History
          </span>
        </AboutDiv>
        <MainContainer>
          <InformationContainer>
            <InformationHeading>
              Any relevant health conditions
            </InformationHeading>
            <InformationDiv>
              {" "}
              {volunteerData.health_condition === "undefined"
                ? ""
                : volunteerData.health_condition}
            </InformationDiv>
          </InformationContainer>
          {/* </MainContainer> */}

          {/* <MainContainer> */}
          <InformationContainer>
            <InformationHeading>Previous illnesses</InformationHeading>
            <InformationDiv>
              {volunteerData.previous_illness === "undefined"
                ? ""
                : volunteerData.previous_illness}
            </InformationDiv>
          </InformationContainer>
          <InformationContainer>
            <InformationHeading>Surgeries</InformationHeading>
            <InformationDiv>
              {volunteerData.surgery_history === "undefined"
                ? ""
                : volunteerData.surgery_history}
            </InformationDiv>
          </InformationContainer>
          <InformationContainer>
            <InformationHeading>Allergies</InformationHeading>
            <InformationDiv>
              {volunteerData.allergies === "undefined"
                ? ""
                : volunteerData.allergies}
            </InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Current medications </InformationHeading>
            <InformationDiv>
              {volunteerData.curr_medication === "undefined"
                ? ""
                : volunteerData.curr_medication}
            </InformationDiv>
          </InformationContainer>
        </MainContainer>
        <EmptyDiv></EmptyDiv>
        <AboutDiv className="entries" style={{ margin: " 1rem" }}>
          <EventAvailableIcon></EventAvailableIcon>
          <span
            style={{
              // color: "#1a202c",
              color: "#20215c",
              fontWeight: "600",
              letterSpacing: "0.4px",
              lineHeight: "32px",
              margin: "0px 0px 0px 8px",
            }}
          >
            Availability
          </span>
        </AboutDiv>
        <MainContainer>
          <InformationContainer>
            <InformationHeading>
              Availability for participation in clinical trials
            </InformationHeading>
            {availability === "Y" && <InformationDiv>Yes</InformationDiv>}
            {availability === "N" && <InformationDiv>No</InformationDiv>}
          </InformationContainer>
          {/* </MainContainer> */}

          {/* <MainContainer> */}
          <InformationContainer>
            <InformationHeading>
              Have you previously participated in clinical trials?{" "}
            </InformationHeading>
            <InformationDiv>
              {previous_clinic_trial === "Y" ? "Yes" : "No"}
            </InformationDiv>
          </InformationContainer>
        </MainContainer>
        <EmptyDiv></EmptyDiv>

        <AboutDiv className="entries" style={{ margin: " 1rem" }}>
          <HomeIcon></HomeIcon>
          <span
            style={{
              color: "#20215c",
              fontWeight: "600",
              letterSpacing: "0.4px",
              lineHeight: "32px",
              margin: "0px 0px 0px 8px",
            }}
          >
            Address
          </span>
        </AboutDiv>

        <MainContainer>
          <InformationContainer>
            <InformationHeading>Division: </InformationHeading>
            <InformationDiv>{volunteerData?.pr_city_name}</InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>District: </InformationHeading>
            <InformationDiv>
              {volunteerData?.permanent_district_name}
            </InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Police station: </InformationHeading>
            <InformationDiv>{volunteerData?.thana_name}</InformationDiv>
          </InformationContainer>
        </MainContainer>

        <MainContainer>
          <InformationContainer>
            <InformationHeading>Post:</InformationHeading>
            <InformationDiv>
              {volunteerData?.permanent_postoffice}
            </InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Village: </InformationHeading>
            <InformationDiv>{volunteerData?.village_name}</InformationDiv>
          </InformationContainer>
        </MainContainer>
        <AboutDiv className="entries" style={{ margin: " 1rem" }}>
          <AttachmentIcon></AttachmentIcon>
          <span
            style={{
              color: "#20215c",
              fontWeight: "600",
              letterSpacing: "0.4px",
              lineHeight: "32px",
              margin: "0px 0px 0px 8px",
            }}
          >
            Attachment
          </span>
        </AboutDiv>
        <MainContainer>
          <InformationContainer>
            <InformationHeading>COVID-19 vaccine card:</InformationHeading>
            <InformationDiv>
              {volunteerData.covid_title === "undefined"
                ? ""
                : volunteerData.covid_title}
            </InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>
              COVID-19 Vaccine Card Description:
            </InformationHeading>
            <InformationDiv>
              {volunteerData.covid_desc === "undefined"
                ? ""
                : volunteerData.covid_desc}
            </InformationDiv>
          </InformationContainer>
          <InformationContainer>
            <InformationHeading>
              COVID-19 Vaccine Card Image:
            </InformationHeading>
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "80px",
                  wight: "auto",
                }}
                src={volunteerData.covid_image}
                alt=""
              />
            </div>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>Father/ Husband NID Title:</InformationHeading>
            <InformationDiv>
              {volunteerData.fathr_or_husb_nid_title === "undefined"
                ? ""
                : volunteerData.fathr_or_husb_nid_title}
            </InformationDiv>
          </InformationContainer>

          <InformationContainer>
            <InformationHeading>
              Father/ Husband NID Description:
            </InformationHeading>
            <InformationDiv>
              {volunteerData.fathr_or_husb_nid_desc === "undefined"
                ? ""
                : volunteerData.fathr_or_husb_nid_desc}
            </InformationDiv>
          </InformationContainer>
          <InformationContainer>
            <InformationHeading>Father/ Husband NID Image:</InformationHeading>
            <div style={{ marginLeft: "1rem", marginTop: "1rem" }}>
              <img
                style={{
                  height: "80px",
                  wight: "auto",
                }}
                src={
                  volunteerData.fathr_or_husb_nid_image === "undefined"
                    ? ""
                    : volunteerData.fathr_or_husb_nid_image
                }
                alt=""
              />
            </div>
          </InformationContainer>
        </MainContainer>
        {volunteerData.approved_status === 1 && (
          <>
            <AboutDiv style={{ margin: " 1rem" }}>
              <HistoryEduIcon></HistoryEduIcon>
              <span
                style={{
                  color: "#20215c",
                  fontWeight: "600",
                  letterSpacing: "0.4px",
                  lineHeight: "32px",
                  margin: "0px 0px 0px 8px",
                }}
              >
                History
              </span>
            </AboutDiv>

            {/* <VolunteerHeading>History List</VolunteerHeading> */}
            <HistoryTable style={{ width: "95%", marginLeft: "1rem" }}>
              <thead
                style={{
                  color: "#ffffff",
                  // margin: "2rem",
                }}
              ></thead>
              <TableHeadTr>
                <TableHeadCell>SL No.</TableHeadCell>
                <TableHeadCell>Study Code</TableHeadCell>
                <TableHeadCell>Date of Last IMP Intake</TableHeadCell>
                <TableHeadCell>Remarks</TableHeadCell>
              </TableHeadTr>

              {history.map((history, index) => {
                return (
                  <tbody key={index}>
                    <tr
                      style={{
                        borderSpacing: 0,
                      }}
                    >
                      <TableCell
                        size="small"
                        style={
                          {
                            // textAlign: "center",
                            // padding: ".2rem",
                          }
                        }
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell size="small">{history.study_code}</TableCell>
                      <TableCell size="small">
                        {moment(history.complet_date).format("DD MMM YYYY")}
                      </TableCell>
                      <TableCell size="small">{history.remarks}</TableCell>
                    </tr>
                  </tbody>
                );
              })}
            </HistoryTable>
          </>
        )}
      </ProfileDiv>
      {/* <PDFViewer>
      <PdfVolProfile volunteerData={volunteerData} history={history} />
  </PDFViewer> */}
      <PdfDiv>
        <PdfVolProfile volunteerData={volunteerData} history={history} />
      </PdfDiv>
    </>
  );
};

export default VolunteerProfile;
